import projectRouteLinks from "./areas/projects/components/ProjectsRoutes/projectRouteLinks";
import tenantRouteLinks from "./areas/tenants/TenantsRoutes/tenantRouteLinks";
import libraryRouteLinks from "./areas/library/components/LibraryRoutes/libraryRouteLinks";
import infrastructureRouteLinks from "./areas/infrastructure/components/InfrastructureRoutes/infrastructureRouteLinks";
import taskRouteLinks from "./areas/tasks/components/TaskRoutes/taskRouteLinks";
import configurationRouteLinks from "./areas/configuration/components/ConfigurationRoutes/configurationRouteLinks";
import projectGroupRouteLinks from "./areas/projects/components/ProjectGroupLayout/projectGroupRouteLinks";
import deploymentRouteLinks from "./areas/deployments/deploymentRouteLinks";
import userProfileRouteLinks from "./areas/users/UserProfileRoutes/userProfileRouteLinks";
import dashboardRouteLinks from "./areas/dashboard/DashboardOverview/dashboardRouteLinks";

export const parameterizedRouteLinks = (root: string) => ({
    root: root ? root : "/",
    dashboard: dashboardRouteLinks(root),
    ...projectRouteLinks(root),
    ...tenantRouteLinks(root),
    ...taskRouteLinks(root),
    ...projectGroupRouteLinks(root),
    ...deploymentRouteLinks(root),
    currentUser: userProfileRouteLinks(root),
    library: libraryRouteLinks(root),
    infrastructure: infrastructureRouteLinks(root),
    configuration: configurationRouteLinks(root),
    styleGuide: `${root}/style-guide`,
    codeGuide: `${root}/code-guide`
});

export default parameterizedRouteLinks("");


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/routeLinks.ts